import {
  IAvailableTimeItemResponse,
  IAvailableTimesResponse,
  IDaysMonthItemResponse,
  IGetAvailableTimesParams,
} from "./available-times.interface";
import { getHourFromUnix, getUnixTimestamp } from "../../utils";
import { useEffect, useState } from "react";

import { AVAILABLE_TIMES } from "./available-times.query";
import { IOptionGeneric } from "../../shared/interface";
import { mapToAvailableTimesRequest } from "./available-times.mapper";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useLazyQuery } from "@apollo/client";
import { useUpdateLocationStore } from "../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";

export const useAvailableTimes = () => {
  const { user } = useUserStore();
  const { reasonForVisit, selectedPets } = useAppointmentStore();
  const [daysOfMonthList, setDaysOfMonthList] = useState<IOptionGeneric[]>([]);
  const [timesList, setTimesList] = useState<IOptionGeneric[]>([]);
  const { locationSelected } = useUpdateLocationStore();

  const [
    availableTimes, { data, loading, error },
  ] = useLazyQuery<{ availableTimesV2: IAvailableTimesResponse }>(AVAILABLE_TIMES, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
  });
  const [currentDay, setCurrentDay] = useState<string>("");

  const getAvailableTimes = ({ reasons, date, isPreviewModal }: IGetAvailableTimesParams) => {
    availableTimes({
      variables: {
        data: mapToAvailableTimesRequest(reasons || reasonForVisit, selectedPets,
          date, isPreviewModal?Number(locationSelected[0].idLocation):Number(user?.location?.idLocation)!),
      },
    });
  };

  useEffect(() => {
    if (data) {
      setDaysOfMonthList(daysOfMonthMap(data.availableTimesV2.daysMonth));
      setTimesList(availableTimesMap(data.availableTimesV2.availableTimes.times, data.availableTimesV2.timeZone));

      const dayUTC = new Date(+data.availableTimesV2.availableTimes.date * 1000).toUTCString().split(" ");
      const day = getUnixTimestamp(new Date(`${dayUTC[1]} ${dayUTC[2]} ${dayUTC[3]}`)).toString();

      setCurrentDay(day.toString());
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setDaysOfMonthList([]);
      setTimesList([]);
    }
  }, [error]);

  return {
    loading,
    getAvailableTimes,
    daysOfMonthList,
    timesList,
    currentDay,
    findAvailability: data?.availableTimesV2,
    appointmentType: data?.availableTimesV2?.appointmentCreateType,
  };
};

export const daysOfMonthMap = (daysMonth: IDaysMonthItemResponse[]): IOptionGeneric[] => {
  return daysMonth.map((e) => ({
    value: `${getUnixTimestamp(new Date(`${e.date} ${e.month} ${e.year}`))}`,
    label: `${e.date.toString().padStart(2, "0")}`,
    disabled: !e.available,
    day: e.day,
    year: e.year,
    month: e.month,
    isNearestAvailableDay: e.isNearestAvailableDay,
  }));
};

export const availableTimesMap = (availableTimes: IAvailableTimeItemResponse[], timeZone: string): IOptionGeneric[] => {
  return availableTimes.map((e) => ({
    value: `${e.time}`,
    label: `${getHourFromUnix(+e.time, timeZone)}`,
    disabled: false,
    resourcesId: `${e.resourcesId}`,
  }));
};
